import api from './axios';

export const getPainelFinanceiro = () => api.get('/painel-financeiro/');
